(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // ══ Filtro Rápido Táctil (Quick Chips) ══
    const quickChips = document.querySelectorAll('.catalog-chip[data-filter]');
    const allCards = document.querySelectorAll('.catalog-grid .pc');

    if (quickChips.length && allCards.length) {
      quickChips.forEach(chip => {
        chip.addEventListener('click', (e) => {
          e.preventDefault();
          const filter = chip.getAttribute('data-filter').toLowerCase();
          
          quickChips.forEach(c => c.classList.remove('is-active'));
          chip.classList.add('is-active');

          allCards.forEach(card => {
            const cardText = (card.innerText || '').toLowerCase();
            if (filter === 'all' || cardText.includes(filter)) {
              card.style.display = '';
            } else {
              card.style.display = 'none';
            }
          });
        });
      });
    }

    // Navegación al seleccionar una colección (radio buttons)
    document.querySelectorAll('.filter-radio').forEach(radio => {
      radio.addEventListener('change', () => {
        const href = radio.getAttribute('data-href');
        if (href) window.location.href = href;
      });
    });

    // Recarga al cambiar un filtro nativo
    const form = document.getElementById('CollectionFiltersForm');
    if (form) {
      form.querySelectorAll('input:not(.filter-radio)').forEach(input => {
        input.addEventListener('change', () => form.submit());
      });
    }

    // Toggles colapsables
    document.querySelectorAll('.filter-group-toggle').forEach(btn => {
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
      });
    });

    // ══ Drawer de filtros en móvil ══
    const openBtn = document.getElementById('openFiltersBtn');
    const closeBtn = document.getElementById('closeFiltersBtn');
    const backdrop = document.getElementById('filtersBackdrop');
    const sidebar = document.getElementById('catalogSidebar');

    function openFiltersDrawer() {
      if (!sidebar) return;
      sidebar.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.classList.add('filters-drawer-open');
      openBtn?.setAttribute('aria-expanded', 'true');
    }

    function closeFiltersDrawer() {
      if (!sidebar) return;
      sidebar.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.classList.remove('filters-drawer-open');
      openBtn?.setAttribute('aria-expanded', 'false');
    }

    openBtn?.addEventListener('click', openFiltersDrawer);
    closeBtn?.addEventListener('click', closeFiltersDrawer);
    backdrop?.addEventListener('click', closeFiltersDrawer);

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sidebar?.classList.contains('is-open')) {
        closeFiltersDrawer();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const toggleBtn = document.querySelector('.header__menu-toggle');
    const closeBtn = document.querySelector('.mobile-drawer__close');
    const drawer = document.getElementById('mobile-menu-drawer');
    const overlay = document.querySelector('.mobile-drawer__overlay');

    if (toggleBtn && drawer) {
      function openDrawer() {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        toggleBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        toggleBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }

      toggleBtn.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
    }

    // Scroll Sticky Header Effect
    const header = document.querySelector('.header');
    if (header) {
      let ticking = false;
      const thresholdDown = 150; // Scroll down threshold to compress header
      const thresholdUp = 20;    // Scroll up threshold to restore header

      function checkScroll() {
        if (window.scrollY > thresholdDown) {
          header.classList.add('header--scrolled');
        } else if (window.scrollY < thresholdUp) {
          header.classList.remove('header--scrolled');
        }
      }

      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            checkScroll();
            ticking = false;
          });
          ticking = true;
        }
      });

      // Initial check in case page loads scrolled down
      checkScroll();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides  = Array.from(this.querySelectorAll('.hero-slider__slide'));
      this.dots    = Array.from(this.querySelectorAll('.hero-slider__dot'));
      this.prevBtn = this.querySelector('.hero-slider__arrow--prev');
      this.nextBtn = this.querySelector('.hero-slider__arrow--next');
      this.current = 0;
      this.delay   = 5500;
      this.timer   = null;

      if (this.slides.length <= 1) return;

      this.prevBtn?.addEventListener('click', () => this.step(-1));
      this.nextBtn?.addEventListener('click', () => this.step(1));
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => { this.goTo(i); this.reset(); });
      });

      // Keyboard navigation
      this.setAttribute('tabindex', '0');
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft')  { this.step(-1); e.preventDefault(); }
        if (e.key === 'ArrowRight') { this.step(1);  e.preventDefault(); }
      });

      // Touch / swipe
      let startX = 0;
      this.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', e => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 48) this.step(diff > 0 ? 1 : -1);
      });

      // Pause on hover / focus
      this.addEventListener('mouseenter', () => this.stopTimer());
      this.addEventListener('mouseleave', () => this.startTimer());
      this.addEventListener('focusin',    () => this.stopTimer());
      this.addEventListener('focusout',   () => this.startTimer());

      this.startTimer();
    }

    goTo(index) {
      const len  = this.slides.length;
      const next = ((index % len) + len) % len;

      this.slides[this.current].classList.remove('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.dots[this.current]?.classList.remove('is-active');
      this.dots[this.current]?.setAttribute('aria-selected', 'false');

      this.current = next;

      this.slides[this.current].classList.add('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'false');
      this.dots[this.current]?.classList.add('is-active');
      this.dots[this.current]?.setAttribute('aria-selected', 'true');
    }

    step(dir)   { this.goTo(this.current + dir); this.reset(); }
    startTimer(){ this.timer = setInterval(() => this.goTo(this.current + 1), this.delay); }
    stopTimer() { clearInterval(this.timer); }
    reset()     { this.stopTimer(); this.startTimer(); }
  }

  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const tracks = document.querySelectorAll('.hr__slider-track');
    
    tracks.forEach((track) => {
      // 1. Cargar reseñas publicadas por usuarios desde las páginas de productos
      try {
        let userReviews = JSON.parse(localStorage.getItem('soportech_global_reviews') || '[]');

        // Migración/recuperación automática de cualquier reseña guardada previamente
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (key && key.startsWith('soportech_reviews_')) {
            try {
              const items = JSON.parse(localStorage.getItem(key) || '[]');
              items.forEach(it => {
                const exists = userReviews.some(u => u.reviewTitle === it.reviewTitle && u.authorName === it.authorName);
                if (!exists) {
                  userReviews.push(it);
                }
              });
            } catch (e) {}
          }
        }

        // Si existen reseñas de usuarios, agregarlas al slider del home
        if (userReviews.length > 0) {
          userReviews.forEach(rev => {
            const author = rev.authorName || 'Comprador verificado';
            const initial = author.charAt(0).toUpperCase();
            const rating = parseInt(rev.rating || 5, 10);
            const prodName = rev.productTitle || 'Altavoz Bluetooth JBL Flip 7';
            const prodUrl = rev.productUrl || '#';
            const bgImg = rev.productBgImage || 'https://soportech-p.myshopify.com/cdn/shop/files/Audifonos_para_venta_tecnologica__202605120045.webp';

            let starsHtml = '';
            for (let s = 1; s <= 5; s++) {
              starsHtml += `<svg class="hr-card__star" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" fill="${s <= rating ? '#facc15' : 'rgba(255,255,255,0.3)'}"/>
              </svg>`;
            }

            const article = document.createElement('article');
            article.className = 'hr-card hr-card--user-review';
            article.innerHTML = `
              <div class="hr-card__bg" style="background-image: url('${bgImg}');" aria-hidden="true"></div>
              <div class="hr-card__overlay" aria-hidden="true"></div>
              <div class="hr-card__content">
                <div class="hr-card__header">
                  <div class="hr-card__rating">${starsHtml}</div>
                  <span class="hr-card__date">${rev.date || 'Reciente'}</span>
                </div>
                <blockquote class="hr-card__quote">
                  <p class="hr-card__text">"${rev.reviewBody || rev.comment || ''}"</p>
                </blockquote>
                <div class="hr-card__footer">
                  <div class="hr-card__author">
                    <div class="hr-card__avatar hr-card__avatar--placeholder">${initial}</div>
                    <div class="hr-card__author-info">
                      <cite class="hr-card__name">${author}</cite>
                      <span class="hr-card__verified">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        Comprador Verificado
                      </span>
                    </div>
                  </div>
                  <a href="${prodUrl}" class="hr-card__product-link">
                    <span class="hr-card__prod-name">${prodName}</span>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="hr-card__prod-arrow">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </a>
                </div>
              </div>
            `;
            track.insertBefore(article, track.firstChild);
          });
        }
      } catch (err) {
        console.error('Error cargando reseñas globales en el home:', err);
      }

      // 2. Controladores del Slider
      const sectionId = track.id.replace('hr-track-', '');
      const prevBtn = document.getElementById(`hr-prev-${sectionId}`);
      const nextBtn = document.getElementById(`hr-next-${sectionId}`);

      if (!prevBtn || !nextBtn) return;

      const getScrollDistance = () => {
        const firstCard = track.querySelector('.hr-card');
        if (!firstCard) return track.clientWidth * 0.8;
        return firstCard.offsetWidth + 24;
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
      });

      const updateButtons = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 4;
        nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
      };

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      setTimeout(updateButtons, 100);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.prod-recs__tab-btn');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const section = this.closest('.prod-recs');
        const targetTab = this.dataset.tab;
        
        if (!section) return;

        // Reset active tab button
        section.querySelectorAll('.prod-recs__tab-btn').forEach(btn => {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        });

        // Set clicked button active
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        // Toggle visibility of panels
        section.querySelectorAll('.prod-recs__content').forEach(panel => {
          panel.classList.remove('active');
        });

        const targetPanel = section.querySelector(`[id^="panel-${targetTab}"]`);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Abrir / Cerrar Formulario
    const openBtn = document.getElementById('ml-open-review-form');
    const closeBtn = document.getElementById('ml-close-review-form');
    const formWrapper = document.getElementById('ml-review-form-wrapper');

    if (openBtn && formWrapper) {
      openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        // 1. Si Judge.me está inyectado, activar su formulario oficial
        const jdgmWriteBtn = document.querySelector('.jdgm-write-rev-link') || 
                             document.querySelector('#judgeme_product_reviews .jdgm-write-rev-link');
        if (jdgmWriteBtn) {
          jdgmWriteBtn.click();
          const jdgmWidget = document.getElementById('judgeme_product_reviews');
          if (jdgmWidget) {
            jdgmWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          return;
        }

        // 2. Si no, abrir el formulario integrado
        formWrapper.style.display = formWrapper.style.display === 'none' ? 'block' : 'none';
        if (formWrapper.style.display === 'block') {
          formWrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    if (closeBtn && formWrapper) {
      closeBtn.addEventListener('click', () => {
        formWrapper.style.display = 'none';
      });
    }

    // Selector de Estrellas en Formulario
    const starPicker = document.getElementById('ml-star-picker');
    const ratingInput = document.getElementById('ml-rating-input');

    if (starPicker && ratingInput) {
      const starBtns = starPicker.querySelectorAll('.ml-star-select-btn');

      const setStars = (rating) => {
        ratingInput.value = rating;
        starBtns.forEach((btn, idx) => {
          const svg = btn.querySelector('svg');
          if (idx < rating) {
            svg.setAttribute('fill', '#facc15');
          } else {
            svg.setAttribute('fill', '#e2e8f0');
          }
        });
      };

      setStars(5);

      starBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const val = parseInt(btn.dataset.value, 10);
          setStars(val);
        });
      });
    }

    // Manejo de Envío Asíncrono (Evita el error 403 de Cloudflare en local)
    const reviewForm = document.getElementById('ml-product-review-form');
    if (reviewForm) {
      reviewForm.addEventListener('submit', (e) => {
        e.preventDefault();

        const submitBtn = reviewForm.querySelector('.ml-reviews__btn-submit');
        const rating = parseInt(ratingInput ? ratingInput.value : '5', 10);
        const nameInput = document.getElementById('ml-review-name');
        const titleInput = document.getElementById('ml-review-title');
        const bodyInput = document.getElementById('ml-review-body');

        const authorName = nameInput ? nameInput.value.trim() : 'Comprador verificado';
        const reviewTitle = titleInput ? titleInput.value.trim() : 'Excelente producto';
        const reviewBody = bodyInput ? bodyInput.value.trim() : '';

        const prodIdInput = document.getElementById('ml-product-id-input');
        const prodId = prodIdInput ? prodIdInput.value : 'default';

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Guardando opinión...';
        }

        const emailInput = document.getElementById('ml-review-email');
        const authorEmail = emailInput ? emailInput.value.trim() : 'cliente@soportech.com';
        const shopDomainInput = document.getElementById('ml-shop-domain-input');
        const shopDomain = shopDomainInput ? shopDomainInput.value : 'soportech-p.myshopify.com';

        const titleEl = document.getElementById('ml-product-title-input');
        const urlEl = document.getElementById('ml-product-url-input');
        const bgEl = document.getElementById('ml-product-last-img-input');

        const productTitle = titleEl ? titleEl.value : '';
        const productUrl = urlEl ? urlEl.value : window.location.pathname;
        const productBgImage = bgEl ? bgEl.value : '';

        // 1. Enviar directamente a la base de datos en la nube de Judge.me
        try {
          const jdgmData = new FormData();
          jdgmData.append('shop_domain', shopDomain);
          jdgmData.append('platform', 'shopify');
          jdgmData.append('id', prodId);
          jdgmData.append('name', authorName);
          jdgmData.append('email', authorEmail);
          jdgmData.append('rating', rating);
          jdgmData.append('title', reviewTitle);
          jdgmData.append('body', reviewBody);
          jdgmData.append('url', window.location.href);

          fetch('https://judge.me/api/v1/reviews', {
            method: 'POST',
            body: jdgmData
          })
          .then(r => r.json())
          .then(data => {
            console.log('Reseña guardada con éxito en la nube de Judge.me:', data);
          })
          .catch(err => {
            console.log('Judge.me cloud sync:', err);
          });
        } catch (e) {}

        // Guardar reseña en localStorage para producto y para el slider del home
        const reviewData = {
          productId: prodId,
          rating: rating,
          authorName: authorName,
          reviewTitle: reviewTitle,
          reviewBody: reviewBody,
          productTitle: productTitle,
          productUrl: productUrl,
          productBgImage: productBgImage,
          date: 'Publicado hace un momento',
          verified: true
        };

        try {
          // 1. Guardar para la ficha de producto
          const storageKey = 'soportech_reviews_' + prodId;
          const existing = JSON.parse(localStorage.getItem(storageKey) || '[]');
          existing.unshift(reviewData);
          localStorage.setItem(storageKey, JSON.stringify(existing));

          // 2. Guardar para el carrusel del home
          const globalKey = 'soportech_global_reviews';
          const globalExisting = JSON.parse(localStorage.getItem(globalKey) || '[]');
          globalExisting.unshift(reviewData);
          localStorage.setItem(globalKey, JSON.stringify(globalExisting));
        } catch (err) {
          // LocalStorage fallback
        }

        // Insertar inmediatamente la nueva reseña en la tirilla estilo Mercado Libre
        const listWrapper = document.getElementById('ml-reviews-list-wrapper');
        if (listWrapper) {
          let starsSvg = '';
          for (let i = 1; i <= 5; i++) {
            starsSvg += `<svg class="ml-star" width="16" height="16" viewBox="0 0 24 24" fill="${i <= rating ? '#facc15' : '#e2e8f0'}"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
          }

          const newArticle = document.createElement('article');
          newArticle.className = 'ml-review-item';
          newArticle.style.backgroundColor = '#f0fdf4';
          newArticle.style.padding = '1.5rem';
          newArticle.style.border = '1px solid #bbf7d0';
          newArticle.style.marginBottom = '1rem';
          newArticle.innerHTML = `
            <div class="ml-review-item__top">
              <div class="ml-review-item__stars">${starsSvg}</div>
              <span class="ml-review-item__date">Publicado hace un momento</span>
            </div>
            <div class="ml-review-item__verified">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#00a650" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
              <span>Compra verificada</span>
            </div>
            <h4 class="ml-review-item__title">${reviewTitle}</h4>
            <p class="ml-review-item__comment">${reviewBody}</p>
            <div class="ml-review-item__bottom">
              <span class="ml-review-item__author">${authorName}</span>
              <div class="ml-review-item__helpful">
                <span class="ml-helpful__text">¿Te resultó útil?</span>
                <button type="button" class="ml-helpful__btn"><span class="ml-helpful__count">Es útil</span></button>
              </div>
            </div>
          `;

          listWrapper.insertBefore(newArticle, listWrapper.firstChild);
          newArticle.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        // Mensaje de confirmación y cierre del formulario
        if (submitBtn) {
          submitBtn.textContent = '¡Opinión publicada!';
          submitBtn.style.backgroundColor = '#16a34a';
        }

        setTimeout(() => {
          if (formWrapper) formWrapper.style.display = 'none';
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Publicar Opinión';
            submitBtn.style.backgroundColor = '';
          }
          if (bodyInput) bodyInput.value = '';
          if (titleInput) titleInput.value = '';
        }, 1200);
      });
    }

    // Cargar reseñas guardadas previamente en localStorage al abrir la página
    try {
      const prodIdInput = document.getElementById('ml-product-id-input');
      const prodId = prodIdInput ? prodIdInput.value : 'default';
      const storageKey = 'soportech_reviews_' + prodId;
      const savedReviews = JSON.parse(localStorage.getItem(storageKey) || '[]');
      const listWrapper = document.getElementById('ml-reviews-list-wrapper');

      if (listWrapper && savedReviews.length > 0) {
        savedReviews.forEach((rev) => {
          let starsSvg = '';
          for (let i = 1; i <= 5; i++) {
            starsSvg += `<svg class="ml-star" width="16" height="16" viewBox="0 0 24 24" fill="${i <= rev.rating ? '#facc15' : '#e2e8f0'}"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
          }
          const savedArticle = document.createElement('article');
          savedArticle.className = 'ml-review-item';
          savedArticle.innerHTML = `
            <div class="ml-review-item__top">
              <div class="ml-review-item__stars">${starsSvg}</div>
              <span class="ml-review-item__date">${rev.date}</span>
            </div>
            <div class="ml-review-item__verified">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#00a650" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
              <span>Compra verificada</span>
            </div>
            <h4 class="ml-review-item__title">${rev.reviewTitle}</h4>
            <p class="ml-review-item__comment">${rev.reviewBody}</p>
            <div class="ml-review-item__bottom">
              <span class="ml-review-item__author">${rev.authorName}</span>
              <div class="ml-review-item__helpful">
                <span class="ml-helpful__text">¿Te resultó útil?</span>
                <button type="button" class="ml-helpful__btn"><span class="ml-helpful__count">Es útil</span></button>
              </div>
            </div>
          `;
          listWrapper.insertBefore(savedArticle, listWrapper.firstChild);
        });
      }
    } catch (e) {}

    // Botón "Es útil" interactivo
    document.querySelectorAll('.ml-helpful__btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.style.color = '#3483fa';
        btn.style.borderColor = '#3483fa';
        if (!btn.dataset.clicked) {
          btn.dataset.clicked = 'true';
          const countSpan = btn.querySelector('.ml-helpful__count');
          if (countSpan) {
            countSpan.textContent = '¡Gracias!';
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Gallery Image Swapping
    const thumbnails = document.querySelectorAll('.thumbnail-image');
    const mainImage = document.querySelector('img[id^="main-product-image-"]');

    if (thumbnails.length > 0 && mainImage) {
      thumbnails.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          const newSrc = this.getAttribute('data-full-src');
          if(newSrc) {
            mainImage.setAttribute('src', newSrc);
            
            // Highlight current thumb
            thumbnails.forEach(t => t.style.opacity = '1');
            this.style.opacity = '0.5';
          }
        });
      });
    }

    // Quantity Selector Logic
    const qtyWrappers = document.querySelectorAll('.product-quantity');
    qtyWrappers.forEach(function(wrapper) {
      const btnMinus = wrapper.querySelector('.quantity-minus');
      const btnPlus = wrapper.querySelector('.quantity-plus');
      const input = wrapper.querySelector('input[type="number"]');

      if(btnMinus && btnPlus && input) {
        btnMinus.addEventListener('click', function() {
          let currentVal = parseInt(input.value) || 1;
          if (currentVal > 1) {
            input.value = currentVal - 1;
          }
        });
        
        btnPlus.addEventListener('click', function() {
          let currentVal = parseInt(input.value) || 1;
          input.value = currentVal + 1;
        });
      }
    });

    // Sticky Add-to-Cart logic
    const stickyBar = document.getElementById('productStickyBar');
    const mainBuyBtn = document.querySelector('.product-add-to-cart');
    const stickyBtn = document.getElementById('stickyAddBtn');
    const productForm = document.querySelector('form[action*="/cart/add"]');

    if (stickyBar && mainBuyBtn) {
      window.addEventListener('scroll', function() {
        const rect = mainBuyBtn.getBoundingClientRect();
        if (rect.bottom < 0 && window.scrollY > 250) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      }, { passive: true });

      if (stickyBtn && productForm) {
        stickyBtn.addEventListener('click', function(e) {
          e.preventDefault();
          productForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }
    }

    // Dynamic Variant Picker Logic (Pills & Swatches)
    const variantPickers = document.querySelectorAll('.product-variant-picker');
    variantPickers.forEach(function(picker) {
      const sectionId = picker.id.replace('variant-picker-', '');
      const selectEl = document.getElementById('Option-' + sectionId);
      const hiddenInput = document.getElementById('product-variant-id-' + sectionId);
      if (!selectEl) return;

      const optionGroups = picker.querySelectorAll('.product-option-group');

      function updateSelectedVariant() {
        // Collect current selections
        const selectedValues = [];
        optionGroups.forEach(function(group, idx) {
          const selectedBtn = group.querySelector('.is-selected');
          const val = selectedBtn ? selectedBtn.getAttribute('data-value') : null;
          selectedValues.push(val);
          const labelSpan = document.getElementById('selected-val-' + sectionId + '-' + idx);
          if (labelSpan && val) labelSpan.textContent = val;
        });

        // Find match in select options
        let matchedOption = null;
        for (let i = 0; i < selectEl.options.length; i++) {
          const opt = selectEl.options[i];
          let match = true;
          for (let j = 0; j < selectedValues.length; j++) {
            const expectedVal = selectedValues[j];
            const optVal = opt.getAttribute('data-option' + (j + 1));
            if (expectedVal && optVal && expectedVal !== optVal) {
              match = false;
              break;
            }
          }
          if (match) {
            matchedOption = opt;
            break;
          }
        }

        if (matchedOption) {
          selectEl.value = matchedOption.value;
          if (hiddenInput) hiddenInput.value = matchedOption.value;

          const priceFormatted = matchedOption.getAttribute('data-price-formatted');
          const priceRaw = parseInt(matchedOption.getAttribute('data-price')) || 0;
          const comparePriceRaw = parseInt(matchedOption.getAttribute('data-compare-price')) || 0;
          const comparePriceFormatted = matchedOption.getAttribute('data-compare-price-formatted');
          const featImg = matchedOption.getAttribute('data-featured-image');

          // Update current price
          const currentPriceEl = document.getElementById('product-price-current-' + sectionId);
          if (currentPriceEl && priceFormatted) {
            currentPriceEl.textContent = priceFormatted;
          }

          // Update sticky bar price
          const stickyPriceEl = document.getElementById('sticky-bar-price');
          if (stickyPriceEl && priceFormatted) {
            stickyPriceEl.textContent = priceFormatted;
          }

          // Update compare price & savings badge
          const comparePriceEl = document.getElementById('product-price-compare-' + sectionId);
          const savingsBadgeEl = document.getElementById('product-savings-badge-' + sectionId);
          if (comparePriceEl && savingsBadgeEl) {
            if (comparePriceRaw > priceRaw) {
              comparePriceEl.textContent = comparePriceFormatted;
              comparePriceEl.style.display = 'inline';
              const discount = Math.round(((comparePriceRaw - priceRaw) / comparePriceRaw) * 100);
              savingsBadgeEl.textContent = '-' + discount + '%';
              savingsBadgeEl.style.display = 'inline-block';
            } else {
              comparePriceEl.style.display = 'none';
              savingsBadgeEl.style.display = 'none';
            }
          }

          // Recalculate Addi installment (divide by 3)
          const addiAmountEl = document.getElementById('addi-installment-amount-' + sectionId) || document.querySelector('[id^="addi-installment-amount-"]');
          if (addiAmountEl && priceRaw > 0) {
            const installmentVal = Math.round(priceRaw / 3);
            const formattedAddi = '$' + (installmentVal / 100).toLocaleString('es-CO', { maximumFractionDigits: 0 });
            addiAmountEl.textContent = formattedAddi;
          }

          // Update button availability
          const isAvailable = !matchedOption.disabled;
          const atcBtn = document.getElementById('AddToCart-' + sectionId);
          const atcText = document.getElementById('AddToCartText-' + sectionId);
          const buyNowBtn = document.getElementById('BuyNow-' + sectionId);

          if (atcBtn) {
            atcBtn.disabled = !isAvailable;
            if (atcText) atcText.textContent = isAvailable ? 'Añadir al carrito' : 'Agotado';
          }
          if (buyNowBtn) {
            buyNowBtn.disabled = !isAvailable;
          }

          // Update featured image
          const mainImg = document.querySelector('img[id^="main-product-image-"]');
          if (featImg && mainImg) {
            mainImg.setAttribute('src', featImg);
          }
        }
      }

      // Add click listeners to buttons
      optionGroups.forEach(function(group) {
        const buttons = group.querySelectorAll('.product-option-pill, .product-option-swatch');
        buttons.forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            if (btn.classList.contains('is-disabled')) return;
            buttons.forEach(b => b.classList.remove('is-selected'));
            btn.classList.add('is-selected');
            updateSelectedVariant();
          });
        });
      });
    });

  });

  } catch(e) { console.error(e); }
})();
})();
